import React, { Component } from "react";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import connect from "react-redux/es/connect/connect";
import moment from "moment";

import { user as getUser } from "../../../store/user/userActions";
import {
  listRooms,
  bookRoom,
  checkOutRoom,
  cancelBooking,
  getOccupancyHistory,
  getCurrentOccupancy,
  setActiveMeetingRoomsTab,
  clearRoomPaginationState,
  setOccupancyHistoryPage,
  setMyOccupancyPage,
  setMyOccupancyFilters,
  setOccupancyHistoryFilters,
} from "../../../store/room/roomActions";
import { userList as getUserList } from "../../../store/leaveReporting/leaveReporingActions";
import { list as getlocation } from "../../../store/location/locationActions";
import MeetingRoomsView from "./MeetingRoomsView";
import { Loader } from "../../common";

export class MeetingRoomsContainer extends Component {


  constructor(props) {
    super(props);
    this.props.getUser(true);
    this.props.listRooms();
    this.props.getUserList({ isActive: "1" });
    this.props.getlocation();
    this.props.getCurrentOccupancy();

    const payload = {
      page: props.occupancyHistoryPage || 1,
      limit: 10,
    };
    if (props.occupancyHistoryFilters) {
      if (props.occupancyHistoryFilters.roomId) payload.roomId = props.occupancyHistoryFilters.roomId;
      if (props.occupancyHistoryFilters.location) payload.location = props.occupancyHistoryFilters.location;
      if (props.occupancyHistoryFilters.fromDate) {
        payload.fromDate = moment(props.occupancyHistoryFilters.fromDate).startOf("day").toISOString();
      }
      if (props.occupancyHistoryFilters.toDate) {
        payload.toDate = moment(props.occupancyHistoryFilters.toDate).endOf("day").toISOString();
      }
    }
    this.props.getOccupancyHistory(payload);
  }

  componentWillUnmount() {
    this.props.clearRoomPaginationState();
  }

  handleTabChange = (tabKey) => {
    this.props.setActiveMeetingRoomsTab(tabKey);
  };

  render() {
    const { userSuccess, roomSuccess, userListSuccess, locationSuccess } = this.props;

    if (
      userSuccess === false ||
      roomSuccess === false ||
      userListSuccess === false ||
      locationSuccess === false
    ) {
      return <Loader />;
    }

    return (
      <MeetingRoomsView
        activeTab={this.props.activeMeetingRoomsTab}
        handleTabChange={this.handleTabChange}
        {...this.props}
      />
    );
  }
}

MeetingRoomsContainer.propTypes = {
  getUser: PropTypes.func.isRequired,
  listRooms: PropTypes.func.isRequired,
  bookRoom: PropTypes.func.isRequired,
  checkOutRoom: PropTypes.func.isRequired,
  cancelBooking: PropTypes.func.isRequired,
  getOccupancyHistory: PropTypes.func.isRequired,
  getCurrentOccupancy: PropTypes.func.isRequired,
  getUserList: PropTypes.func.isRequired,
  getlocation: PropTypes.func.isRequired,
  userSuccess: PropTypes.bool.isRequired,
  roomSuccess: PropTypes.bool.isRequired,
  userListSuccess: PropTypes.bool.isRequired,
  locationSuccess: PropTypes.bool.isRequired,
  roomList: PropTypes.array.isRequired,
  userList: PropTypes.array.isRequired,
  locationList: PropTypes.array.isRequired,
  bookPending: PropTypes.bool,
  checkoutPending: PropTypes.bool,
  cancelBookingPending: PropTypes.bool,
  occupancyHistoryList: PropTypes.array,
  occupancyHistoryPagination: PropTypes.object,
  currentOccupancyList: PropTypes.array,
  occupancyHistoryPending: PropTypes.bool,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({
  user: state.user.user,
  userSuccess: state.user.userSuccess,
  roomList: state.room.roomList,
  roomSuccess: state.room.roomSuccess,
  roomPending: state.room.roomPending,
  userList: state.leaveReporting.userList,
  userListSuccess: state.leaveReporting.userListSuccess,
  locationList: state.location.locationList,
  locationSuccess: state.location.locationSuccess,
  bookPending: state.room.bookPending,
  checkoutPending: state.room.checkoutPending,
  cancelBookingPending: state.room.cancelBookingPending,
  occupancyHistoryList: state.room.occupancyHistoryList,
  occupancyHistoryPagination: state.room.occupancyHistoryPagination,
  currentOccupancyList: state.room.currentOccupancyList,
  occupancyHistoryPending: state.room.occupancyHistoryPending,
  activeMeetingRoomsTab: state.room.activeMeetingRoomsTab,
  occupancyHistoryPage: state.room.occupancyHistoryPage,
  myOccupancyPage: state.room.myOccupancyPage,
  myOccupancySelectedDate: state.room.myOccupancySelectedDate,
  occupancyHistoryFilters: state.room.occupancyHistoryFilters,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUser,
      listRooms,
      bookRoom,
      checkOutRoom,
      cancelBooking,
      getOccupancyHistory,
      getCurrentOccupancy,
      getUserList,
      getlocation,
      setActiveMeetingRoomsTab,
      clearRoomPaginationState,
      setOccupancyHistoryPage,
      setMyOccupancyPage,
      setMyOccupancyFilters,
      setOccupancyHistoryFilters,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MeetingRoomsContainer);
